/* eslint-disable import/prefer-default-export */

export function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/helpers/component.js